export default __webpack_public_path__ + "static/media/logo-placeholder.6e95db98.png";